export default __webpack_public_path__ + "files/House Agriculture Committee-687a2266a51136b3e485ceb1699a1359.png";